import React from 'react'
import { BoxProps, Flex } from '../../../vanilla';
import LoadingOverlay from '../../../components/loading-overlay';
import { PAYMENT_METHOD_IDS } from '../../../utils/constants';
import { useGlobalStore } from '../../../store/hooks/useStore';


interface PaymentMethodButtonProps extends BoxProps<React.ElementType> {
  containerId: string
}

export const PaymentMethodButton = ({ containerId, ...rest }: PaymentMethodButtonProps) => {

  const {hasApplePayButtonRendered, setHasApplePayButtonRendered} =useGlobalStore()
  const isApplePay = containerId.startsWith(PAYMENT_METHOD_IDS.APPLE_PAY)

  return (
    <Flex
      id={containerId}
      style={{ width: '100%', height: 44 }}
      position="relative"
      align="center"
      borderRadius="base"
      {...rest}
    >
      {isApplePay && (
        <apple-pay-button
          buttonstyle="black"
          type="pay"
          locale="en-gb"
          style={{ width: '100%', height: '44px'}}
        ></apple-pay-button>
      )}
      <LoadingOverlay
        isLoading={isApplePay ? !hasApplePayButtonRendered : true}
        spinnerSize="sm"
        containerStyles={{ backgroundColor: 'rgba(255, 255, 255, 0.8)' }}
      />
    </Flex>
  );
};